module.exports = __webpack_public_path__ + "static/media/48266322_2308771595864685_255738768168845312_o.68c3efa5.jpg";